import React, {useState, useEffect} from 'react'
import { connect } from 'react-redux';
import styles from "./Report.module.css";
import Table from './Table'
import Handler from './Handler'
import {
  getReport,
  setReport,
  getYears,
  getSpecialty,
  schoolYear,
  getCathedra,
  getGroup,
  getPeriod,
  getSchema,
  trashReport,
  trashSchema,
  trashCafedra,
  trashGroup,
  trashCalcAnswer,
  getAchievDetails,
  resetAchieveDetails,
  updateAchieveDetails,
  getAchieveFile,
  recalc
} from '../../actions/report'
import {MONTHS} from '../../utils/const'
import { Spinner } from 'react-bootstrap';
import { createNotification } from '../notifications/notifications';


const Report = ({
  data, 
  loading, 
  getReport,
  setReport, 
  getSpecialty, 
  getCathedra, 
  schoolYear, 
  special, 
  state,
  scy, 
  cathedra, 
  getGroup, 
  groups, 
  period, 
  getPeriod, 
  schema, 
  getSchema, 
  trashReport, 
  recalc,
  recalc_loading,
  recalc_answer, 
  trashCafedra, 
  trashSchema, 
  trashCalcAnswer,
  trashGroup,
  getAchievDetails,
  getAchieveFile,
  updateAchieveDetails,
  achieveDetails,
  resetAchieveDetails
}) => {


  const [faculty, setFaculty] = useState(localStorage.getItem('fak') || null);
  const [schemas, setSchema] = useState(localStorage.getItem('schema') || null);
  const [year, setYear] = useState(localStorage.getItem('year') || null);
  const [month, setMonth] = useState(localStorage.getItem('period') || null);
  const [cathedras, setCathedra] = useState(localStorage.getItem('kaf') || null);
  const [group, setGroup] = useState(localStorage.getItem('grop') || null);

  useEffect(() => {
    getSpecialty();
    schoolYear();
    trashReport();
  }, [])  

  useEffect(() => {
    if (year) {
      getPeriod(year);
      getSchema(year);
      // при выбранном факультете кафедры грузит эффект в Handler
      !faculty && getCathedra(0, 0);
    } else {
      trashSchema();
    }
  }, [year]);

  // единственное место загрузки групп — иначе запрос дублируется
  useEffect(() => {
    if (year) {
      getGroup(cathedras || 0, faculty || 0, year, '', state['Ввод индивидуальных достижений. Администратор.']);
    } else {
      trashGroup();
    }
  }, [cathedras, faculty, year]);

  const handleGetTable = () => {
    if (!month) {
      createNotification('error', 'Выберите Месяц');
      return
    }

    if (month && month.length && group && group.length && year && year.length && schemas && schemas.length) {
    getReport(schemas, group, year, month);
  } else if (localStorage.getItem('schema') && localStorage.getItem('year') && localStorage.getItem('period') && localStorage.getItem('grop')) {
    getReport(localStorage.getItem('schema'), localStorage.getItem('grop'), localStorage.getItem('year'), localStorage.getItem('period'));
  }
  }

  useEffect(() => {
    !loading && recalc_answer == true &&
      setTimeout(() => {
        trashCalcAnswer();
      }, 2000);
  }, [recalc_answer])
  

  const handleTrash = () => {
    setYear(null);
    setFaculty(null);
    setCathedra(null);
    trashReport();
    localStorage.removeItem('fak');
    localStorage.removeItem('schema');
    localStorage.removeItem('year');
    localStorage.removeItem('period');
    localStorage.removeItem('kaf');
    localStorage.removeItem('grop');
  }

  const handleRecalc = () => {
    if(schemas && month && year && scy && schemas.length && month.length && year.length && scy.length) {
      recalc(schemas, year, month, scy);
    }
  }

  useEffect(() => {
    if (!localStorage.getItem('year')) {
      setSchema(null);
      setMonth(null);
      localStorage.removeItem('year');
    }
  }, [year])
  
  useEffect(() => {
    if (!localStorage.getItem('kaf')) {
      setCathedra(null);
      localStorage.removeItem('kaf');
    }
  }, [faculty])

  useEffect(() => {
    if (!localStorage.getItem('kaf') || !localStorage.getItem('year')) {
      setGroup(null);
      localStorage.removeItem('grop');
    }
  }, [cathedras, year])

  if (state['Ввод индивидуальных достижений. Администратор.'] == 'Нет' && state['Ввод индивидуальных достижений.'] == 'Нет') {
    return <div className="captions h1">Доступ закрыт</div>;
  }

  return (
    <div className={styles.wrapperReset}>
        <div className="captions h1">Модель цифрового портрета курсанта</div>
        
        <div className={styles.wrapperHandAndBut}>
          <div>
            <div className={styles.wrapperHandles}>
              <Handler name='Год' localName='year' handle={year} setHandle={setYear} trashGroup={trashGroup} trashCafedra={trashCafedra} options={scy} getReport={getReport} data={data}/>
              <Handler name='Схема' localName='schema' handle={schemas} setHandle={setSchema} trashGroup={trashGroup} trashCafedra={trashCafedra} options={schema} getReport={getReport} data={data}/>
              <Handler name='Месяц' localName='period' handle={month} setHandle={setMonth} trashGroup={trashGroup} trashCafedra={trashCafedra} options={MONTHS} getReport={getReport} data={data} period={period}/>
            </div>
            <div className={styles.wrapperHandles2}>
              <Handler name='Факультет' localName='fak' handle={faculty} getCathedra={getCathedra} setHandle={setFaculty} trashGroup={trashGroup} trashCafedra={trashCafedra} options={special} getReport={getReport} data={data}/>
              <Handler name='Кафедра' localName='kaf' handle={cathedras} setHandle={setCathedra} trashGroup={trashGroup} trashCafedra={trashCafedra} options={cathedra} getReport={getReport} data={data}/>
              <Handler name='Группа' localName='grop' handle={group} setHandle={setGroup} trashGroup={trashGroup} trashCafedra={trashCafedra} options={groups} getReport={getReport} data={data}/>
            </div>
          </div>

        <div className={styles.buttonsReset}>
        <button className={styles.buttonRecalc} onClick={handleRecalc}>Пересчитать</button>
        <div className={styles.blockRe}>
        <button className={styles.buttonReset} onClick={handleGetTable}>Обновить</button>
        <button className={styles.buttonResetTrash} onClick={handleTrash}>Сброс</button>
        </div>
        </div>
        </div>

        {
          !recalc_loading && recalc_answer == true && 
            <div className={styles.popup}>
              <p className={styles.popup_text}>Обновление прошло успешно!</p>
            </div>
        }
        
        {
          !loading && data && 
          <div className={styles.wrapperTableReset}>
            <Table
              state={state}
              setReport={setReport}
              data={data}
              year={year}
              month={month}
              achieveDetails={achieveDetails}
              getAchievDetails={getAchievDetails}
              resetAchieveDetails={resetAchieveDetails}
              getAchieveFile={getAchieveFile}
              updateAchieveDetails={updateAchieveDetails}
              schema={schemas}
              group={group}
              facultLabel={special?.find(({idfaculty}) => idfaculty == faculty)?.faculty || ''}
              groupLabel={groups?.find(({gid}) => gid == group)?.name || ''}
            />
          </div>
        }
        
        {
          loading && 
          <div className="text-center">
            <Spinner animation="border" role="status">
              <span className="sr-only">Loading...</span>
            </Spinner>
          </div>
        }

        {
          (!data || !data.length > 0) && !loading &&
          <div className={styles.hint}>
            <i>
            <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 24 24" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M12 6a3.939 3.939 0 0 0-3.934 3.934h2C10.066 8.867 10.934 8 12 8s1.934.867 1.934 1.934c0 .598-.481 1.032-1.216 1.626a9.208 9.208 0 0 0-.691.599c-.998.997-1.027 2.056-1.027 2.174V15h2l-.001-.633c.001-.016.033-.386.441-.793.15-.15.339-.3.535-.458.779-.631 1.958-1.584 1.958-3.182A3.937 3.937 0 0 0 12 6zm-1 10h2v2h-2z"></path><path d="M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"></path></svg>
            </i><p>Задайте параметры таблицы</p></div>
        }

        {
          recalc_loading && 
          <div className="text-center">
            <Spinner animation="border" role="status">
              <span className="sr-only">Loading...</span>
            </Spinner>
          </div>
        }

    </div>
  )
}

const mapStateToProps = (state) => ({
  data: state.report.report,
  loading: state.report.loading,
  years: state.report.years,
  special: state.report.special,
  scy: state.report.scy,
  cathedra: state.report.cathedra,
  groups: state.report.groups,
  period: state.report.period,
  schema: state.report.schema,
  recalc_loading: state.report.recalc_loading,
  recalc_answer: state.report.recalc_answer,
  state: state.auth.access_modes['Режимы'],
  achieveDetails: state.report.achieveDetails
});

export default connect(mapStateToProps, { 
   getReport,
   setReport, 
   getYears, 
   getSpecialty, 
   schoolYear, 
   getCathedra, 
   getGroup, 
   getPeriod, 
   getSchema, 
   trashReport, 
   trashSchema, 
   trashCafedra, 
   trashGroup, 
   recalc,
   trashCalcAnswer,
   getAchievDetails,
   resetAchieveDetails,
   getAchieveFile,
   updateAchieveDetails
  })(Report);
